import Vue from 'vue'
import Vuex from 'vuex'
import App from './modules/App'
import Commons from './modules/Commons'

import Game from './modules/Game'
import Socket from './modules/Socket'
import World3D from './modules/World3D'


Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        app: App,
        commons: Commons,
        game: Game,
        socket: Socket,
        world: World3D
    }
})


